import { render } from "./ContactComp.vue?vue&type=template&id=77b78684"
import script from "./ContactComp.vue?vue&type=script&lang=js"
export * from "./ContactComp.vue?vue&type=script&lang=js"

import "./ContactComp.vue?vue&type=style&index=0&id=77b78684&lang=css"

import exportComponent from "D:\\Dev\\PenseBeteV2\\repo\\pensebete_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QForm,QInput,QCheckbox});
